import { useState, useEffect } from 'react';
import { MunicipalityComparative } from '@/graphql/types/municipality';
import { getDistinctVibrantColors } from '@/utils/functions/colors';

export function useSeriesColors(comparativeMunicipalitiesData?: MunicipalityComparative[]) {
  const [seriesColors, setSeriesColors] = useState<
    { dataKey: string; name: string; fillColor: string; strokeColor: string }[]
  >([]);

  useEffect(() => {
    if (!comparativeMunicipalitiesData?.length) return;

    const uniqueNames = Array.from(
      new Set(comparativeMunicipalitiesData.map((m) => m.municipality.name_municipality))
    ).filter(Boolean) as string[];

    if (seriesColors.length === uniqueNames.length) return;

    const colors = getDistinctVibrantColors(uniqueNames.length);

    const newSeriesColors = uniqueNames.map((name, index) => ({
      dataKey: `series${index + 1}`,
      name,
      fillColor: colors[index].fillColor,
      strokeColor: colors[index].strokeColor,
    }));

    setSeriesColors(newSeriesColors);
  }, [comparativeMunicipalitiesData]);

  return seriesColors;
}
